<!--
附带组织结构树的公共面板组件
-->
<template>
<x-tree-panel :data="departData" @selected="onSelect">
  <slot></slot>
</x-tree-panel>
</template>
<script>
  import {queryMyDepartTreeList, searchByKeywords} from '@/api/api'
  import XTreePanel from './XTreePanel'

  export default {
    name: 'XDepartPanel',
    components: {
      XTreePanel
    },
    data() {
      return {
        departData: []
      }
    },
    methods: {
      callback(key) {
        //console.log(key)
      },
      loadData() {
        this.refresh();
      },
      loadTree() {
        var that = this
        that.departData = []
        queryMyDepartTreeList().then((res) => {
          if (res.success && res.result ) {
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              that.departData.push(temp)
            }
            // that.departData = [];
            this.loading = false
          }
          that.userIdentity = res.message
        })
      },
      refresh() {
        this.loading = true
        this.loadTree()
      },
      onSearch(value) {
        let that = this
        if (value) {
          searchByKeywords({keyWord: value,myDeptSearch:'1'}).then((res) => {
            if (res.success) {
              that.departTree = []
              for (let i = 0; i < res.result.length; i++) {
                let temp = res.result[i]
                that.departTree.push(temp)
              }
            } else {
              that.$message.warning(res.message)
            }
          })
        } else {
          that.loadTree()
        }

      },
      onSelect(selectedNode) {
        console.info();
        this.$emit('selected', selectedNode);
      },
    },
    created() {
      this.currFlowId = this.$route.params.id
      this.currFlowName = this.$route.params.name
      this.loadTree()
    },
  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>